
export interface IGetCodes {
  Code: string
  Description: string
  Status: string
  Display_Order: number
}
export interface IGetCodesAvailableFeature {
  Code: string
  Description: string
  Status: string
  Display_Order: number|null
}


export interface IGetCodesName {
  Code: number
  Name: string
  Display_Order: number
  Status: string
}

export interface IStudyUnitPracticeTest  {
  Test_Name: string
  Course_ID: number
  Course_Plan_ID: number
  Course_Test_Id: number
  Course_Master_Id: number
  Course_Name: string
  Course_Plan_Type_Code: string
  Course_Plan_Type_Codes?: string[]
  Course_Test_Status_Type_Code: string
  Path_Name: string
  Study_Unit_Id: number
  Study_Unit_Name: string
  Exam_Year: number
  Exam_agency_ID: number
  Exam_Agency_Name: string
  Test_Type_Code: string
  Number_Of_Questions: any
  Created_By: string
  Creation_Date: string
  Updated_By: string
  Updation_Date: string
  Deleted_Ind: string
}

